import React, { Component } from 'react'
import { withRouter } from 'react-router-dom'
import InsightsTable from '../../components/insights_table'
import './styles.css'
import { connect } from 'react-redux'

export class Insights extends Component {
  render() {
    const { isAuthenticated, isTokenExpired } = this.props
    return <div>{isAuthenticated && !isTokenExpired && <InsightsTable />}</div>
  }
}

const mapStateToProps = (state, ownProps) => ({
  isAuthenticated: state.auth.isAuthenticated,
  errorMessage: state.auth.errorMessage,
  isTokenExpired: state.auth.isTokenExpired,
})

export default withRouter(connect(mapStateToProps)(Insights))
